import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import { NowSlideIn } from '@now/dpl';

@Component({
  selector: 'now-wbsuche-lib-facetten-slide-in',
  templateUrl: './facetten-slide-in.component.html',
  styleUrls: ['./facetten-slide-in.component.scss'],
  imports: [NgClass]
})
export class FacettenSlideInComponent implements OnDestroy, AfterViewInit {
  @Input()
  loading: boolean = false;

  @Output()
  resetAllFilters = new EventEmitter<void>();

  @ViewChild('offcanvas') offcanvas!: ElementRef<HTMLElement>;

  private dplSlideIn?: NowSlideIn;

  ngAfterViewInit(): void {
    this.dplSlideIn = NowSlideIn.init(this.offcanvas.nativeElement);
  }

  ngOnDestroy(): void {
    this.closeFacettenSlideOut();
  }

  private closeFacettenSlideOut() {
    this.dplSlideIn?.hide();
    this.dplSlideIn?.dispose();
  }
}
